module.exports = __webpack_public_path__ + "static/media/memories.dc8bbfe3.png";